export const Settings = {
  appHeaderName: 'Cloud Forest',
  languages: [
    { label: 'English', value: 'en' },
    { label: 'தமிழ்', value: 'tn' },
    { label: 'हिंदी', value: 'hi' },
  ],
  release: !(!process.env.NODE_ENV || process.env.NODE_ENV === 'development'),
}